import React from "react";
import FlatButton from "material-ui/FlatButton";
import Button from "@techsoftware/happay-widgets/Button";
import PropTypes from "prop-types";

export default class SecondaryButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleKeyDowm = e => {
        if (e.keyCode === 13) {
            this.props.onClick(e);
        }
    };

    render() {
        let style = {
            color: "#54698d",
            height: "auto",
            lineHeight: 1,
            padding: "10px 16px",
            borderRadius: "3px",
            fontFamily: "Roboto-Medium",
            fontSize: "12px",
            fontWeight: 500,
            border: "solid 1px #e8edf4",
            backgroundColor: "#ffffff",
            margin: "0px 5px",
            pointerEvents: this.props.disabled ? "none" : "auto"
        };
        if (this.props.isWidgetComp) {
            return (
                <Button
                    onClick={this.props.onClick}
                    type="button"
                    text={this.props.label}
                    startIcon={this.props.startIcon}
                    variant="secondary"
                    size={this.props.size || "normal"}
                    className={this.props.className}
                    {...this.props}
                />
            );
        }
        return (
            <FlatButton
                {...this.props}
                backgroundColor={"#ffffff"}
                hoverColor={"#ffffff"}
                className="secondaryButton"
                labelStyle={{ fontSize: "12px", padding: 0, verticalAlign: "inherit" }}
                style={Object.assign(style, this.props.style)}
                onKeyDown={this.handleKeyDowm}
            />
        );
    }
}

SecondaryButton.propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.string
};

SecondaryButton.defaultProps = {
    onClick: () => {},
    label: "Cancel"
};
